import { forwardRef, memo, type Component } from 'react';
import map from 'lodash/map';
import split from 'lodash/split';
// Material UI imports
import { type BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Skillmore UI Components
import Scrollable from '@empathco/ui-components/src/elements/Scrollable';

type RoleDescriptionProps = {
  readonly autofit?: boolean;
  readonly description?: string | null;
}

const RoleDescription = forwardRef<Component<BoxProps>, RoleDescriptionProps>(({
  autofit,
  description = ''
}, ref) => (
  <Scrollable ref={ref} autofit={autofit}>
    {map(split(description, '\n'), (line, index) => (
      <Typography key={index} paragraph>
        {line}
      </Typography>
    ))}
  </Scrollable>
));

RoleDescription.displayName = 'RoleDescription';

export default memo(RoleDescription);
